<template>
  <div :class="$style.container">
    <i :class="[ $style.iconInline, 'jc-info-circle' ]" />
    <p>
      <MarkdownInline :mdTemplate="text" />
    </p>
  </div>
</template>
<script>
import { MarkdownInline } from '@jumpcloud/ui-components';

export default {
  name: 'InformationalText',

  components: {
    MarkdownInline,
  },

  props: {
    text: {
      type: String,
      default: '',
    },
  },
};
</script>

<style module>
.container {
  align-items: baseline;
  display: flex;
  justify-content: flex-start;
}

.iconInline {
  color: var(--jc-color-informational-base);
  font-size: 11px;
  margin-right: 5px;
}
</style>
